import { Component, Type, ViewChild, ViewContainerRef } from '@angular/core';
import { BaseTunnelObject } from '../../model/base-tunnel-object';
import { CONFIG_CONTEXT } from '../../../../enum/config-context.enum';
import { KitchenTunnelValidationComponent } from '../../kitchen/kitchen-tunnel-validation/kitchen-tunnel-validation.component';
import { StorageTunnelValidationComponent } from '../../storage/storage-tunnel-validation/storage-tunnel-validation.component';
import { BathroomTunnelValidationComponent } from '../../bathroom/bathroom-tunnel-validation/bathroom-tunnel-validation.component';
import { BathroomHbmTunnelValidationComponent } from '../../bathroom-hbm/bathroom-hbm-tunnel-validation/bathroom-hbm-tunnel-validation.component';
import { CarpentryTunnelValidationComponent } from '../../carpentry/carpentry-tunnel-validation/carpentry-tunnel-validation.component';
import { BasketTunnelValidationComponent } from '../../basket/basket-tunnel-validation/basket-tunnel-validation.component';

@Component({
  selector: 'ng-casto-base-validation',
  templateUrl: './base-validation.component.html',
})
export class BaseValidationComponent extends BaseTunnelObject {
  private static readonly DEFAULT_PLACEHOLDER_IMAGE_SRC = 'assets/img/models/stevia-creme.jpg';
  protected placeholderImageSrc: string = BaseValidationComponent.DEFAULT_PLACEHOLDER_IMAGE_SRC;

  @ViewChild('validationContainer', { read: ViewContainerRef, static: true })
  private validationContainer!: ViewContainerRef;

  protected subscribeToObservable() {
    this.subscriptionList.push(
      this.tunnelNavigationStore.getCurrentStep().subscribe(step => {
        if (step) {
          this.placeholderImageSrc = step.placeholderImageSrc ?? BaseValidationComponent.DEFAULT_PLACEHOLDER_IMAGE_SRC;
        }
      }),
      this.tunnelNavigationStore.getCurrentContext().subscribe(context => {
        if (context) this.initBodyContentFromContext(context);
      })
    );
  }

  // @ts-ignore
  private initBodyContentFromContext(context: CONFIG_CONTEXT) {
    switch (context) {
      case CONFIG_CONTEXT.KITCHEN:
        this.loadComponent(KitchenTunnelValidationComponent);
        break;
      case CONFIG_CONTEXT.STORAGE:
        this.loadComponent(StorageTunnelValidationComponent);
        break;
      case CONFIG_CONTEXT.BATHROOM_V2:
        this.loadComponent(BathroomTunnelValidationComponent);
        break;
      case CONFIG_CONTEXT.BATHROOM:
        this.loadComponent(BathroomHbmTunnelValidationComponent);
        break;
      case CONFIG_CONTEXT.CARPENTRY:
        this.loadComponent(CarpentryTunnelValidationComponent);
        break;
      case CONFIG_CONTEXT.BASKET:
        this.loadComponent(BasketTunnelValidationComponent);
        break;
      default:
        break;
    }
  }

  private loadComponent(component: Type<any>): void {
    this.validationContainer.clear();
    this.validationContainer.createComponent(component);
  }

  protected readonly CONFIG_CONTEXT = CONFIG_CONTEXT;
}
